export const SETFORMFIELDS = "SETFORMFIELDS";
export const CLEARFORMFIELDS = "CLEARFORMFIELDS";

export const setTemplateFormFields = (payload) => ({
    type:SETFORMFIELDS,
    payload:payload
});

export const clearTemplateFormFields = (payload) => ({
    type:CLEARFORMFIELDS,
    payload:payload
});